import styled from 'styled-components';

export const TooltipsStyled = styled.div`
  display: inline-flex;
  margin-left: 8px;
  vertical-align: text-top;

  .icon_question {
    fill: ${(props) =>
      props.theme[props.brand].chartBox.TypeChangeBtnGroupColor[1]};
    width: 16px;
    height: 16px;
    cursor: pointer;
    vertical-align: baseline;
  }
  .icon_question:hover {
    fill: ${(props) =>
      props.theme[props.brand].chartBox.TypeChangeBtnGroupColor[0]};
  }
`;
